export enum AudienceOrderType {
  NotSet = 0,
  House = 1,
  OnPoint = 2,
  Custom = 3,
  Nls = 4,
}
